/* eslint-disable import/no-cycle */
/* eslint-disable eqeqeq */
/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { theme } from '@mtsbank/ui-kit';
function calculateLeftPosition(slidesCount, dotWidth = 8, gap = 12) {
  const position = (dotWidth * slidesCount + gap * (slidesCount - 1)) / 2;
  return `calc(50% - ${position}px)`;
}
const Dot = styled.div<{
  active: boolean;
  variant: 'default' | 'premiumBanking';
}>`
  transition: width 0.5s;
  width: ${theme.spacings.xs3}px;
  height: ${theme.spacings.xs3}px;
  background-color: ${({
  active,
  variant
}) => active ? variant == 'premiumBanking' ? theme.colors.emerald.primary : '#EA1F49' : 'rgba(116, 119, 150, 0.3)'};
  border-radius: ${theme.radiuses.md / 2}px;
`;
const DotsContainer = styled.div<{
  slidesCount: number;
}>`
  display: none;

  @media (max-width: ${theme.breakpoints.sm - 1}px) {
    display: grid;
    grid-auto-flow: column;
    gap: ${theme.spacings.xs2}px;
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: ${({
  slidesCount
}) => calculateLeftPosition(slidesCount)};
  }
`;
export const Styled = {
  Dot,
  DotsContainer
};